import React from "react";
import { useLeaderboard } from "../../hooks/useLeaderboard";

const LeaderboardComponent = () => {
  const { scores, loading, error, fetchLeaderboard } = useLeaderboard();

  if (loading) {
    return (
      <div className="leaderboard">
        <h2>🏆 High Scores</h2>
        <p>Loading scores...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="leaderboard">
        <h2>🏆 High Scores</h2>
        <p className="error">{error}</p>
      </div>
    );
  }

  return (
    <div className="leaderboard" style={{ textAlign: "center" }}>
      <h2 style={{ 
        fontFamily: "'Press Start 2P', monospace",
        color: "#38bdf8", 
        marginBottom: "12px",
        fontSize: "14px"
      }}>🏆 High Scores</h2>
      <table style={{ 
        width: "90%", 
        borderCollapse: "collapse", 
        marginTop: "6px",
        color: "white",
        fontSize: "10px"
      }}>
        <thead>
          <tr style={{ borderBottom: "2px solid #38bdf8" }}>
            <th style={{ padding: "4px", textAlign: "center", fontSize: "10px" }}>Rank</th>
            <th style={{ padding: "4px", textAlign: "left", fontSize: "10px" }}>Player</th>
            <th style={{ padding: "4px", textAlign: "right", fontSize: "10px" }}>Score</th>
          </tr>
        </thead>
        <tbody>
          {scores.map((entry, index) => (
            <tr 
              key={index} 
              style={{ 
                backgroundColor: index % 2 === 0 ? "rgba(56, 189, 248, 0.1)" : "transparent",
                borderBottom: "1px solid rgba(56, 189, 248, 0.3)"
              }}
            >
              <td style={{ padding: "4px", textAlign: "center", fontSize: "10px" }}>
                {index === 0 ? "🥇" : index === 1 ? "🥈" : index === 2 ? "🥉" : index + 1}
              </td>
              <td style={{ padding: "4px", textAlign: "left", fontWeight: "bold", fontSize: "10px" }}>{entry.name}</td>
              <td style={{ padding: "4px", textAlign: "right", color: "#f59e0b", fontSize: "10px" }}>{entry.score}</td>
            </tr>
          ))}
          {scores.length === 0 && (
            <tr>
              <td colSpan="3" style={{ padding: "12px", textAlign: "center", fontSize: "10px" }}>
                No scores yet. Be the first!
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LeaderboardComponent;
